module.exports = __webpack_public_path__ + "img/blades.e43a5fc2.jpg";